import { Team, FixtureOpponent } from "../types/team";
import TeamLogo from "./TeamLogo";

type Props = {
  team: Team;
  opponent: FixtureOpponent;
};

function Side({ team }: { team: Team }) {
  return (
    <>
      <TeamLogo logo={team.logo} name={team.name} className="w-10 h-10" />
      <strong>{team.name}</strong> <span className="text-gray-600">({team.country})</span>
    </>
  );
}

export default function MatchRow({ team, opponent }: Props) {
  const home = opponent.isHome ? opponent : team;
  const away = opponent.isHome ? team : opponent;

  return (
    <span className="flex items-center gap-2 flex-wrap text-gray-800">
      <Side team={home} /> 🏠 vs <Side team={away} />
      <span className="text-gray-500 text-sm">– Pot {opponent.pot}</span>
    </span>
  );
}
